import { IChangeManualDateAction } from '../../../actions/bookingCalendar/date/changeDateRange'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IChangeManualDateAction,
): IBookingCalendarStore {
  return {
    ...state,
    dates: {
      ...state.dates,
      manual: action.startDate,
    },
  }
}
